import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Controls } from '../../../components/controls/Controls';
import AppointmentTypeToIntakePlanMappingModal from './AppointmentTypeToIntakePlanMappingModal';

export default function AppointmentTypeSettingButton(props) {
  const {
    appointmentTypeSetting,
    selectedPlans,
    refreshParent,
    setSuccessMessage,
    setErrorMessage,
  } = props;

  const [mainModalVisible, setMainModalVisible] = useState(false);

  return (
    <>
      <Controls.Button
        sx={{ margin: '7px 0' }}
        variant="contained"
        onClick={() => {
          setMainModalVisible(true);
        }}
        text="Edit Intake Plans"
      />
      <AppointmentTypeToIntakePlanMappingModal
        appointmentTypeSetting={appointmentTypeSetting}
        isOpen={mainModalVisible}
        handleClose={() => setMainModalVisible(false)}
        intakePlanOptions={selectedPlans}
        refreshParent={refreshParent}
        setErrorMessage={setErrorMessage}
        setSuccessMessage={setSuccessMessage}
      />
    </>
  );
}

AppointmentTypeSettingButton.propTypes = {
  selectedPlans: PropTypes.arrayOf(
    PropTypes.shape({
      actionListId: PropTypes.number,
      id: PropTypes.number,
      isIntakePlan: PropTypes.bool,
      languagesToTranslate: PropTypes.arrayOf(PropTypes.string),
      uniqueName: PropTypes.string,
    }),
  ).isRequired,
  refreshParent: PropTypes.func.isRequired,
  setErrorMessage: PropTypes.func.isRequired,
  setSuccessMessage: PropTypes.func.isRequired,
  appointmentTypeSetting: PropTypes.shape({
    name: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
};
